/**
 * @file chat module entry
 * @author malcolmmzma
 */

import React from 'react';
import { Loading } from '@tencent/spaui';
import { useRequest } from 'ahooks';
import { useHistory, useParams } from 'react-router-dom';
import _ from 'lodash';

import { getSessionDetail, ISessionDetailResponse } from '../../../api/analysis';

import ChatInstance from './instance';
import AgentContainer from '../components/container';

import '../index.less';
import { useSearchParams } from '../hooks/useSearchParams';

// chat已完成但无log信息
const isChatError = (res?: ISessionDetailResponse) => {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { check_finish, log_list } = res || {};
  return check_finish === 1 && log_list?.length === 0;
};

export interface ChatProps extends React.HTMLProps<HTMLDivElement> {
  userInfo?: any; // 用户信息
}

const Chat = (props: ChatProps) => {
  const { } = props;

  const history = useHistory();

  const { sessionId: defaultChatSessionId = '' } = useParams<{ sessionId?: string }>();

  const { searchParamStr } = useSearchParams();

  const { data, loading } = useRequest(getSessionDetail, {
    defaultParams: [{ session_id: defaultChatSessionId }],
    refreshDeps: [defaultChatSessionId],
    ready: !!defaultChatSessionId,
    onSuccess(res, params) {
      if (isChatError(res)) {
        console.error('获取会话详情失败', res, params);
        history.replace(`/analysis/ai-agent/new?${searchParamStr}`);
      }
      return res;
    },
  });
  const { check_finish: checkFinish, log_list: logList } = data || {};
  const isError = isChatError(data);

  return (
    <AgentContainer>
      {!loading && !isError ? (
        <ChatInstance
          chatSessionId={defaultChatSessionId}
          agentId={_.get(logList, '0.agent_id', 0)}
          getDetailAction={() => Promise.resolve({ is_chat_completed: checkFinish === 1, log_list: logList || [] })}
        />
      ) : <Loading />}
    </AgentContainer>
  );
};

export default Chat;
